import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Grid, Icon } from "semantic-ui-react";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";
import { Fetchexecutequery } from "../../../services/process/BRS1/brsService7";
import "../css/dashboard_new.css";

const DashboardComponent = () => {
  const [kpiData, setKpiData] = useState({
    total_po: 0,
    total_grp: 0,
    total_invoice: 0,
    matched_invoice: 0,
    unmatched_invoice: 0,
    po_value: 0,
    invoice_value: 0,
    matched_value: 0,
  });

  const [poStatusChart, setPoStatusChart] = useState({ series: [], labels: [] });
  const [grpStatusChart, setGrpStatusChart] = useState({ series: [], labels: [] });
  const [invStatusChart, setInvStatusChart] = useState({ series: [], labels: [] });

  const [tableData, setTableData] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    fetchKpis();
    fetchPoStatus();
    fetchGrpStatus();
    fetchInvStatus();
  }, []);

  const dbCall = async (query) => {
    const payload = { query };
    const creds = Fetchexecutequery();
    const res = await axios.post(creds[1], payload, creds[0]);
    return res.data;
  };

  const fetchKpis = async () => {
    try {
      const result = await dbCall(`
        SELECT
          (SELECT COUNT(*) FROM bct_ap_poc.po_header) AS total_po,
          (SELECT COUNT(*) FROM bct_ap_poc.grp_details) AS total_grp,
          (SELECT COUNT(*) FROM bct_ap_poc.inv_field) AS total_invoice,
          (SELECT COUNT(*) FROM bct_ap_poc.inv_field WHERE status = 'Sent for Payment') AS matched_invoice,
          (SELECT COUNT(*) FROM bct_ap_poc.inv_field WHERE status = 'Open') AS unmatched_invoice,
          (SELECT IFNULL(SUM(po_total),0) FROM bct_ap_poc.po_header) AS po_value,
          (SELECT IFNULL(SUM(invoice_total),0) FROM bct_ap_poc.inv_field) AS invoice_value,
          (SELECT IFNULL(SUM(invoice_total),0) FROM bct_ap_poc.inv_field WHERE status='Sent for Payment') AS matched_value;
      `);

      setKpiData(result[0]);
    } catch (err) {
      console.error("KPI fetch error", err);
    }
  };

  const fetchPoStatus = async () => {
    const res = await dbCall(`SELECT status, COUNT(*) AS total FROM bct_ap_poc.po_header GROUP BY status`);
    setPoStatusChart({ series: res.map((r) => Number(r.total)), labels: res.map((r) => r.status) });
  };

  const fetchGrpStatus = async () => {
    const res = await dbCall(`SELECT status, COUNT(*) AS total FROM bct_ap_poc.grp_details GROUP BY status`);
    setGrpStatusChart({ series: res.map((r) => Number(r.total)), labels: res.map((r) => r.status) });
  };

  const fetchInvStatus = async () => {
    const res = await dbCall(`SELECT status, COUNT(*) AS total FROM bct_ap_poc.inv_field GROUP BY status`);
    setInvStatusChart({ series: res.map((r) => Number(r.total)), labels: res.map((r) => r.status) });
  };

  const fetchTableData = async (table, status) => {
    let query = `SELECT * FROM bct_ap_poc.${table}`;
    if (status !== "ALL") query += ` WHERE status='${status}'`;

    const data = await dbCall(query);
    setTableData(data);
    setIsPopupOpen(true);
  };

  const usdFormat = (n) =>
    new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(n || 0);

  const numberFormat = (n) => new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(n || 0);

  const kpiCard = (title, value, icon, color, isCurrency = false) => (
    <div style={{ background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)", borderRadius: 16, padding: 20, color: "white", boxShadow: "0 8px 24px rgba(0,0,0,0.2)", display: "flex", flexDirection: "column", gap: 8 }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ opacity: 0.8 }}>{title}</div>
        <Icon name={icon} size="large" style={{ color }} />
      </div>
      <div style={{ fontSize: 28, fontWeight: 700 }}>{isCurrency ? usdFormat(value) : numberFormat(value)}</div>
    </div>
  );

  const donutOptions = (chart, table) => ({
    labels: chart.labels,
    legend: { position: "bottom" },
    chart: {
      events: {
        legendClick: (_, seriesIndex) => fetchTableData(table, chart.labels[seriesIndex]),
        dataPointSelection: (_, __, config) => fetchTableData(table, chart.labels[config.dataPointIndex]),
      },
    },
  });

  const columnDefs = Object.keys(tableData[0] || {}).map((key) => ({ headerName: key, field: key }));

  return (
    <div style={{ padding: 24, background: "#f4f6f8", minHeight: "100vh" }}>
      <div style={{ fontSize: 26, fontWeight: 700, marginBottom: 20 }}> AP Reconciliation Dashboard</div>

      <Grid columns={4} stackable>
        <Grid.Row>
          <Grid.Column>{kpiCard("Total PO", kpiData.total_po, "file alternate", "#4cafef")}</Grid.Column>
          <Grid.Column>{kpiCard("Total GRP", kpiData.total_grp, "boxes", "#66bb6a")}</Grid.Column>
          <Grid.Column>{kpiCard("Total Invoices", kpiData.total_invoice, "file invoice", "#ffa726")}</Grid.Column>
          <Grid.Column>{kpiCard("Matched Invoices", kpiData.matched_invoice, "check circle", "#42a5f5")}</Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column>{kpiCard("Unmatched Invoices", kpiData.unmatched_invoice, "warning circle", "#ef5350")}</Grid.Column>
          <Grid.Column>{kpiCard("PO Value", kpiData.po_value, "dollar sign", "#ab47bc", true)}</Grid.Column>
          <Grid.Column>{kpiCard("Invoice Value", kpiData.invoice_value, "money bill", "#26c6da", true)}</Grid.Column>
          <Grid.Column>{kpiCard("Matched Value", kpiData.matched_value, "chart line", "#8bc34a", true)}</Grid.Column>
        </Grid.Row>
      </Grid>

      <Grid columns={3} stackable style={{ marginTop: 24 }}>
        <Grid.Row>
          <Grid.Column>
            <div className="chart-card">
              <div className="chart-title">PO Status</div>
              <ReactApexChart type="donut" height={300} series={poStatusChart.series} options={donutOptions(poStatusChart, "po_header")} />
            </div>
          </Grid.Column>

          <Grid.Column>
            <div className="chart-card">
              <div className="chart-title">GRP Status</div>
              <ReactApexChart type="donut" height={300} series={grpStatusChart.series} options={donutOptions(grpStatusChart, "grp_details")} />
            </div>
          </Grid.Column>

          <Grid.Column>
            <div className="chart-card">
              <div className="chart-title">Invoice Status</div>
              <ReactApexChart type="donut" height={300} series={invStatusChart.series} options={donutOptions(invStatusChart, "inv_field")} />
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      {isPopupOpen && (
        <div className="popup-overlay">
          <div className="popup-content">
            <button onClick={() => setIsPopupOpen(false)} className="close-popup-btn">X</button>
            <div className="ag-theme-alpine" style={{ height: 400, width: "100%" }}>
              <AgGridReact rowData={tableData} columnDefs={columnDefs} defaultColDef={{ sortable: true, filter: true, resizable: true }} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardComponent;